import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../components/Layout/AuthContext';

const Forbidden: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleBackHome = () => navigate('/');

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <Result
      status="403"
      title="403"
      subTitle="抱歉，您没有访问该页面的权限。"
      extra={[
        <Button key="home" type="primary" onClick={handleBackHome}>
          返回首页
        </Button>,
        <Button key="logout" onClick={handleLogout}>
          退出重新登录
        </Button>,
      ]}
    />
  );
};

export default Forbidden;
